import "./migration.css";
import RegisterTwo from "../../components/registertwo";
import { FaGavel, FaUsers } from "react-icons/fa";

const Migration = () => {
  return (
    <section className="migration-section">
      <div className="container text-center migration-main">
        <div className="text-center migration-title-container">
          <h1 className="display-4">MIGRACIÓN</h1>
          <p className="lead">
            Facilita tu proceso de migración con nuestra asesoría integral.
          </p>
        </div>

        <div className="row g-4 mb-4">
          {/* Tarjeta: Abogados Aprobados */}
          <div className="col-md-6">
            <div className="card migration-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaGavel className="icon" />
                </div>
                <h2 className="migration-card-title">Abogados Aprobados</h2>
                <p className="text-muted">
                  Confía en profesionales aprobados por el Departamento de Justicia para guiarte.
                </p>
              </div>
            </div>
          </div>
          {/* Tarjeta: Asesoría Comunitaria */}
          <div className="col-md-6">
            <div className="card migration-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaUsers className="icon" />
                </div>
                <h2 className="migration-card-title">Asesoría Comunitaria</h2>
                <p className="text-muted">
                  Conecta con organizaciones que ofrecen asesoramiento integral en inmigración.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-warning me-2">
            CONECTA CON ABOGADOS
          </button>
          <button className="btn btn-warning">
            CONOCE MÁS
          </button>
        </div>
      </div>

      {/* Componente de registro (a ancho completo) */}
      <div className="migration-vertical-section">
        <RegisterTwo />
      </div>
    </section>
  );
};

export default Migration;